<!------------------------------------------------------------->
<ng-template #searchSuggestionstemp>
  <div class="w-100 d-flex justify-content-center position-absolute search-suggestions">
    <div class="container d-flex flex-column align-items-start   p-3 shadow rounded " (clickOutside)="searchSuggestions = []"  *ngIf="searchSuggestions?.length" >
      <ng-container *ngFor="let entry of searchSuggestions">
        <button class="t-btn" (click)="openSuggestionText(entry.name)">
          {{entry.name}} ( {{entry.type == 'type' ? 'Type' : (entry.type == 'cat' ? 'Category' : 'Subcategory')}} )
        </button>
        <ng-container *ngIf="entry?.types">
          <button class="t-btn"  *ngFor="let subTypes of entry?.types" (click)="openSuggestionText(subTypes.name) ">
            {{subTypes.name}} (Type)
          </button>
        </ng-container>
        <ng-container *ngIf="entry?.subcats">
          <ng-container *ngFor="let subEntry of entry?.subcats">
            <button class="t-btn"  (click)="openSuggestionText(subEntry.name); ">
              {{subEntry.name}} (Subcategory)
            </button>
            <ng-container *ngIf="subEntry?.types">
              <button class="t-btn"  *ngFor="let subTypes of subEntry?.types" (click)=" openSuggestionText( subTypes.name);  ">
                {{subTypes.name}} (Type)
              </button>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
   
  </ng-template>
<!------------------------------------------------------------->


<div class="search-mobile">
  <div class="position-absolute w-100" style="top: calc(100%);">
    <div *ngTemplateOutlet="searchSuggestionstemp"></div>
  </div>
  <div class="my-input">
    <i class="fa-solid fa-search"></i>
    <input type="text" [(ngModel)]="maps.search" placeholder="Look for Services Nearby" (keydown)="getSearchSuggestions($event)" (keydown.enter)="openFilterModal(filterPopup)" />
  </div>
</div>
<div class="search-header">
  <div class="container">
    <div *ngTemplateOutlet="searchSuggestionstemp; context: {data: searchSuggestions}"></div>
    <div class="bar" [class.active]="arrow">
      <div class="my-input search" style="position: relative">
        <div class="my-input__title">{{ "" }}</div>
        <input type="text" [(ngModel)]="maps.search" placeholder="Search"  (keydown)="getSearchSuggestions($event)" (keydown.enter)="openFilterModal(filterPopup)" />
      </div>
      <div class="my-input">
        <div class="my-input__title">Postal</div>
        <input type="text" [(ngModel)]="maps.postalCode" placeholder="Postal Code" />
      </div>
      <div class="my-input">
        <div class="my-input__title">Radius</div>
        <select [(ngModel)]="maps.radius">
          <option value="0" selected disabled>Radius</option>
          <option *ngFor="let radius of [0.2, 1, 2, 5, 'All']" [value]="radius">
            {{ radius == "All" ? "All" : radius < 1 ? radius * 1000 + "m" : radius + "km" }}
          </option>
        </select>
      </div>
      <div class="icon-search" (click)="openFilterModal(filterPopup)">
        <i class="fa-solid fa-search"></i>
      </div>
      <div class="keyword" *ngIf="popularKeywords.length > 0">
        <p class="keyword__title">Popular Search</p>
        <p class="d-none" *ngFor="let row of popularKeywords">{{ row.text }}</p>
        <div #keywordContainer class="buttons">
          <button class="keyword__btn" *ngFor="let row of popularKeywords" (click)="maps.search = row.text; openFilterModal(filterPopup)">{{ row.text }}</button>
        </div>
      </div>
      <!-- <i class="fa-solid fa-angle-down arrow" (click)="arrow = !arrow"></i> -->
    </div>
    <ng-content></ng-content>
  </div>
</div>
<!-- <div class="header">
  <div class="overlay">
    <div class="bar" [class.active]="arrow">
      <div class="my-input search" style="position: relative">
        <div class="my-input__title">{{ "" }}</div>
        <input type="text" [(ngModel)]="maps.search" placeholder="Search" (keydown.enter)="openFilterModal(filterPopup)" />
      </div>
      <div class="my-input">
        <div class="my-input__title">Postal</div>
        <input type="text" [(ngModel)]="maps.postalCode" placeholder="Postal Code" />
      </div>
      <div class="my-input">
        <div class="my-input__title">Radius</div>
        <select [(ngModel)]="maps.radius">
          <option value="0" selected disabled>Radius</option>
          <option *ngFor="let radius of [0.2, 1, 2, 5, 'All']" [value]="radius">
            {{ radius == "All" ? "All" : radius < 1 ? radius * 1000 + "m" : radius + "km" }}
          </option>
        </select>
      </div>
      <div class="icon-search" (click)="openFilterModal(filterPopup)">
        <i class="fa-solid fa-search"></i>
      </div>
      <div class="keyword" *ngIf="popularKeywords.length > 0">
        <p class="keyword__title">Popular Search</p>
        <p class="d-none" *ngFor="let row of popularKeywords">{{ row.text }}</p>
        <div #keywordContainer class="buttons">
          <button class="keyword__btn" *ngFor="let row of popularKeywords" (click)="maps.search = row.text; openFilterModal(filterPopup)">{{ row.text }}</button>
        </div>
      </div>
    </div>
  </div>
</div> -->

<ng-template #filterPopup let-modal>
  <div class="modal-map">
    <div class="modal-map__close" (click)="modal.dismiss('Cross click')">
      <i class="fa-solid fa-times"></i>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-6">
          <app-google-map [params]="maps" (view)="viewProduct($event)"></app-google-map>
        </div>
        <div class="col-lg-6">
          <div class="modal-map__nav">
            <div>
              <button (click)="handleSearch(row)" *ngFor="let row of [0.2, 1, 2, 5, 'All']">
                {{ row == "All" ? "All" : row < 1 ? row * 1000 + "m" : row + "km" }}
              </button>
            </div>
          </div>
          <div *ngIf="!maps.all && !maps.home && !maps.business">
            <div class="alert alert-warning text-center mb-2" role="alert"><i class="fa-solid fa-checkmark"></i> Please Check Home or Business</div>
          </div>
          <div *ngIf="maps.products?.length < 1">
            <div class="alert alert-secondary text-center" role="alert"><i class="fa-solid fa-shopping-cart"></i> No Products Available</div>
          </div>
          <div class="d-flex flex-wrap">
            <ng-container *ngFor="let keywordSubCat of maps.subCategoriesBasedOnKeyWords">
              <ng-container *ngFor="let type of keywordSubCat.subcategoryTypes">
                <button class="btn btn-sm btn-outline-primary mr-2 mt-2" [class.active]="selectedTypesId.has(type.id)" (click)="toggleTypeAndSearch(type)">
                  {{ type.name }}
                </button>
              </ng-container>
            </ng-container>
          </div>

          <div *ngIf="maps.products?.length > 0" class="modal-map__body">
            <div class="products">
              <common-product-card-view (selected)="productSelectedChanged(row, $event)" [isSelected]="i < 5" (view)="viewProduct($event)" *ngFor="let row of maps.products; index as i" [list]="row" [isCommunityProduct]="true" [isSearch]="true"></common-product-card-view>
              <button class="btn btn-outline-primary my-2 addrecomm-btn" (click)="openRecommendationForm()">+</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-marketplace #marketplace [share]="true"></app-marketplace>
  </div>
</ng-template>

<ng-template #popup let-modal>
  <div>
    <div class="modal-popup__close" (click)="modal.dismiss('Cross click')">
      <i class="fa-solid fa-times"></i>
    </div>
    <div class="modal-popup__modal-body">
      <app-my-carousel-swiper [navigation]="false" [config]="carouselOptions" (onSlideChange)="popupSlider($event)">
        <div class="swiper-slide">
          <img style="height: 300px; width: 100%; object-fit: cover" src="https://swiperjs.com/demos/images/nature-1.jpg" />
        </div>
        <div class="swiper-slide">
          <img style="height: 300px; width: 100%; object-fit: cover" src="https://swiperjs.com/demos/images/nature-2.jpg" />
        </div>
        <div class="swiper-slide">
          <img style="height: 300px; width: 100%; object-fit: cover" src="https://swiperjs.com/demos/images/nature-3.jpg" />
        </div>
        <div class="swiper-slide">
          <img style="height: 300px; width: 100%; object-fit: cover" src="https://swiperjs.com/demos/images/nature-4.jpg" />
        </div>
        <div class="swiper-slide">
          <img style="height: 300px; width: 100%; object-fit: cover" src="https://swiperjs.com/demos/images/nature-5.jpg" />
        </div>
        <div class="swiper-slide">
          <img style="height: 300px; width: 100%; object-fit: cover" src="https://swiperjs.com/demos/images/nature-6.jpg" />
        </div>
        <div class="swiper-slide">
          <img style="height: 300px; width: 100%; object-fit: cover" src="https://swiperjs.com/demos/images/nature-3.jpg" />
        </div>
        <div class="swiper-slide">
          <img style="height: 300px; width: 100%; object-fit: cover" src="https://swiperjs.com/demos/images/nature-4.jpg" />
        </div>
        <div class="swiper-slide">
          <img style="height: 300px; width: 100%; object-fit: cover" src="https://swiperjs.com/demos/images/nature-5.jpg" />
        </div>
        <div class="swiper-slide">
          <img style="height: 300px; width: 100%; object-fit: cover" src="https://swiperjs.com/demos/images/nature-6.jpg" />
        </div>
      </app-my-carousel-swiper>
      <div class="my-popup">
        <div class="my-popup__title">{{ titles[currentIndex] }}</div>
        <div class="my-popup__desc">{{ descriptions[currentIndex] }}</div>
        <div class="my-popup__buttons">
          <button class="my-button-3">Explore</button>
          <button class="my-button-3 secondary">Login</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
